module.exports = __webpack_public_path__ + "static/media/menuGear.d0e9c6e9.svg";